import { Component, Inject, inject, model } from '@angular/core';
import { CustomerServiceControllerService } from '../../../core/generated/api/customerServiceController.service';
import { MaterialModule } from '../../material/material.module';
import { DialogData } from '../../../my-account/customer-service/customer-service.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-dialog-register-customer-service',
    standalone: true,
    imports: [MaterialModule, FormsModule],
    templateUrl: './dialog-register-customer-service.component.html',
    styleUrl: './dialog-register-customer-service.component.scss'
})
export class DialogRegisterCustomerServiceComponent {
  private customerServiceService = inject(CustomerServiceControllerService);
  private deviceService = inject(DeviceDetectorService);
  
  newCustomerService = model(this.data.newCustomerService);
  subject: string = '';
  message: string = '';
  category: 'duvida' | 'suporte' | 'financeiro' | 'outros' = 'duvida';
  urgent: boolean = false;
  isMobile = this.deviceService.isMobile();

  constructor(
    public dialogRef: MatDialogRef<DialogRegisterCustomerServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  createRegisterCustomerService() {
    let body = {
      subject: this.subject,
      message: this.message,
    };

    this.customerServiceService
      .openCustomerService(body)
      .subscribe((customerService) => {
        this.data.newCustomerService = customerService;
        this.dialogRef.close(customerService);
      });
  }
}
